import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
const WithBTSMemberList = ({ onActiveIndex, setOnActiveIndex }) => {
  const { i18n, t } = useTranslation();

  const member = [
    'RM',
    'JIN',
    'SUGA',
    'J-HOPE',
    'JIMIN',
    'V',
    'JUNGKOOK',
    'ARMY',
  ];

  const memberColor = [
    '#e0f9fe',
    '#fceff5',
    '#f4ffd3',
    '#effeec',
    '#e9eafd',
    '#fdf8cf',
    '#f4dbfd',
    '#e2d3fc',
  ];

  return (
    <>
      {member &&
        member.map((item, idx) => (
          <li
            className={`${
              onActiveIndex === idx ? 'active' : ''
            } cursor-pointer `}
            style={{
              backgroundColor: onActiveIndex === idx ? memberColor[idx] : '',
            }}
            key={`bts_member_${idx}`}
            onClick={() => setOnActiveIndex(idx)}
          >
            <img
              src={`/img/v2/svg/heart.svg`}
              className="absolute hidden w-[13px] h-[13px] top-[-25px] left-[50%] ml-[-10px]
                    transition-opacity duration-500 hover:opacity-100 "
              style={{
                display: onActiveIndex === idx ? 'block' : '',
              }}
            />
            <img src={`/img/v2/withbts/withBTS_${item}.png`} className="char" />
            <div className="stroke-container font-TmoneyRoundWind font-extrabold ">
              <span
                style={{
                  WebkitTextStroke:
                    onActiveIndex === idx ? `5px ${memberColor[idx]}` : '',
                  textFillColor:
                    onActiveIndex === idx ? `5px ${memberColor[idx]}` : '',
                  WebkitTextFillColor:
                    onActiveIndex === idx ? `5px ${memberColor[idx]}` : '',
                }}
              >
                {t(item)}
              </span>
              <span
                style={{
                  color: onActiveIndex === idx ? '#000' : '',
                }}
              >
                {t(item)}
              </span>
            </div>
          </li>
        ))}
    </>
  );
};

export default WithBTSMemberList;
